<template>
    <div>
        <button-secondary @click="open">
            <template slot="icon"><i class="fa fa-plus"></i></template> Zubuchbare Ausstattung hinzufügen
        </button-secondary>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Zubuchbare Ausstattung hinzufügen
                </template>

                <input-text v-model="name" class="mb-4">
                    Name der zubuchbaren Austattung
                </input-text>

                <input-text v-model="quantity" class="mb-4" type="number">
                    Anzahl
                    <template slot="helper">
                        Verfügbare Anzahl an Ausstattungen. Ausstattung ist nichtmehr zubuchbar, wenn
                        keins mehr für den Zeitpunkt vorhanden ist.
                    </template>
                </input-text>

                <div class="flex justify-end">
                    <button-primary v-show="!loading" @click="create">
                        <template slot="icon"><i class="fa fa-save"></i></template> Speichern
                    </button-primary>
                </div>

                <loading v-show="loading"></loading>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue"
import Modal from "../Modal.vue";
import Loading from "../UI/Loading.vue";
import InputText from "../UI/InputText.vue";

export default {
    name: "PostableEquipmentCreate",

    components: {InputText, Loading, Modal, ButtonSecondary, ButtonPrimary},

    data: () => ({
        showModal: false,
        loading: false,
        name: '',
        quantity: 1,
    }),

    methods: {
        open() {
            this.name = '';
            this.showModal = true;
        },
        create() {
            this.loading = true;
            window.axios.post('/admin/postable_equipment', {
                name: this.name,
                quantity: this.quantity,
            }).then(() => {
                this.loading = false;
                this.showModal = false;
                this.$root.$emit('alert', 'Ausstattung erstellt');
                this.$emit('created');
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        },
    }
}
</script>

<style scoped>

</style>
